/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_S3Inputs */

const en_tut_pergi_s3 = /** @type {(inputs: Tut_Pergi_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Tandai sudah dibaca** when you are done. Older briefings stay openable from the list on the left of the dialog.`)
};

const id_tut_pergi_s3 = /** @type {(inputs: Tut_Pergi_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Tandai sudah dibaca** setelah selesai. Ringkasan lama tetap bisa dibuka lagi dari daftar di sisi kiri dialog.`)
};

/**
* | output |
* | --- |
* | "Press **Tandai sudah dibaca** when you are done. Older briefings stay openable from the list on the left of the dialog." |
*
* @param {Tut_Pergi_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_s3 = /** @type {((inputs?: Tut_Pergi_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_s3(inputs)
	return en_tut_pergi_s3(inputs)
});